import styled from 'styled-components';

import upperHalf from '../../../images/pipe-section-image-upper.png';
import belowHalf from '../../../images/pipe-section-image-below.png';

import React, { useState } from 'react';
// import AskModal from '../../common/AskModal';
import StyledInput from '../../common/StyledInput';
import StyledOutput from '../../common/StyledOutput';
import ModalLabel from '../../common/ModalLabel';
import Modal from '../../common/Modal';
import { useEffect } from 'react';
import SelectPipeDia from './SelectPipeDia';
import AlertLabel from '../../common/AlertLabel';
import { toFixedSafe } from '../../../lib/styles/perttierNumber';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { getDiaRelatedValue } from './library-pipe-conveyor';

const CalcPipeSectionArea = ({ isOpenModal, setIsOpenModal, parentState: input, setParentState: setInput }) => {
    /* 언어 선택 */
    const language = useSelector((state) => state.language);
    const isEN = language.language === 'EN' ? true : false;
    const isJP = language.language === 'JP' ? true : false;
    // const isKR = language.language === 'KR' ? true : false;

    const [isOpenAreaCalcModal, setIsOpenAreaCalcModal] = useState(false);
    const [isOpenPipeDiaSelectModal, setIsOpenPipeDiaSelectModal] = useState(false);

    const [capacity, setCapacity] = useState(input?.capacity || '');
    const [beltSpeed, setBeltSpeed] = useState(input?.beltSpeed || '');
    const [bulkDensity, setBulkDensity] = useState(input?.specificGravity || '');
    const [surchargeAngle, setSurchargeAngle] = useState(input?.surchargeAngle || '');
    const [requiredSectionArea, setRequiredSectionArea] = useState(input?.requiredSectionArea || '');
    const [pipeDiameter, setPipeDiameter] = useState(input?.pipeDiameter || '');
    const [beltWidth, setBeltWidth] = useState(input?.beltWidth || '');
    // const [overlapAngle, setOverlapAngle] = useState(input?.overlapAngle || '');

    const [materialHeight, setMaterialHeight] = useState(input.pipeInfo?.materialHeight || 0);
    const [levelHeight, setLevelHeight] = useState(input.pipeInfo?.levelHeight || 0);
    const [theta, setTheta] = useState(input.pipeInfo?.theta || 0); // 각도형식
    const [length, setLength] = useState(input.pipeInfo?.length || 0);
    const [maxArea, setMaxArea] = useState(input.pipeInfo?.maxArea || 0); // 원의 면적
    const [fillingRatio, setFillingRatio] = useState(input.pipeInfo?.fillingRatio || 0);
    const [maxLumpSize, setMaxLumpSize] = useState(input.pipeInfo?.maxLumpSize || 0);
    const [isValidate, setIsValidate] = useState(false);
    const [isBelow, setIsBelow] = useState(true);

    /* 입력값이 변경되면 계산 결과를 리셋하는 기능을 구현하기 위해 */
    const prevPipeDiameter = useRef(pipeDiameter);
    const prevSurchargeAngle = useRef(surchargeAngle);

    useEffect(() => {
        // 인풋값을 수정면 무조건 아웃풋을 초기화. Calculate 버튼을 누르지 않는 실수를 없애기 위해!
        if (prevPipeDiameter.current !== pipeDiameter) {
            // 입력값이 달라지면 초기화
            initializeOutput();
            setIsValidate(false);
            prevPipeDiameter.current = pipeDiameter;
        }
        if (prevSurchargeAngle.current !== surchargeAngle) {
            // 입력값이 달라지면 초기화
            initializeOutput();
            setIsValidate(false);
            prevSurchargeAngle.current = surchargeAngle;
        }

        const A = Number(requiredSectionArea);
        const D = Number(pipeDiameter);
        const 𝛼 = (Number(surchargeAngle) * Math.PI) / 180; // 라디안 변환

        const isValidInput = (value) => !isNaN(value) && value > 0;

        if (isValidInput(A) && isValidInput(D) && isValidInput(𝛼)) {
            setIsValidate(true);
        } else {
            setIsValidate(false);
        }
    }, [requiredSectionArea, pipeDiameter, surchargeAngle]);

    const initializeOutput = () => {
        setTheta(0);
        setLength(0);
        setFillingRatio(0);
        setMaterialHeight(0);
        setLevelHeight(0);
        setMaxLumpSize(0);
    };

    /* Max Area 계산 */
    useEffect(() => {
        const D = Number(pipeDiameter) / 1000;
        const A = Math.PI * D**2 / 4;

        setMaxArea(Math.ceil(A * 100000) / 100000);
    }, [pipeDiameter]);

    /* Required Section Area 계산 - 모달창에서 계산하는 부분임. */
    useEffect(() => {
        const Q = Number(capacity); // Number함수는 숫자로 변환할 수 있는 경우 숫자로 변환하여 반환. null이나 빈문자는 0. true는 1, false는 0. 그 외는 NaN 반환.
        const 𝜌 = Number(bulkDensity);
        const v = Number(beltSpeed);

        const isValidInput = (value) => !isNaN(value) && value > 0;

        if (isValidInput(Q) && isValidInput(𝜌) && isValidInput(v)) {
            const Iv = Q / (3.6 * 𝜌); // m3/sec
            const area = Iv / v; // m2
            setRequiredSectionArea(Math.ceil(area * 100000) / 100000);
            setIsValidate(true);
        } else {
            setRequiredSectionArea(0);
            setIsValidate(false);
        }
    }, [beltSpeed, bulkDensity, capacity]);

    const onConfirmMainModal = () => {
        // TODO
        setInput((prev) => ({
            ...prev,
            requiredSectionArea,
            surchargeAngle,
            pipeDiameter,
            beltWidth,
            overlapAngle: getDiaRelatedValue(pipeDiameter, 'overlapAngle'),
            pipeInfo: {
                materialHeight,
                levelHeight,
                theta,
                length,
                maxArea,
                fillingRatio,
                maxLumpSize,
            }
        }));

        setIsOpenModal(false);
    };

    const onConfirmSubModal = () => {
        // TODO

        setIsOpenAreaCalcModal(false);
    };

    const onCancel = () => {
        setIsOpenModal(false);
    };

    const handleClick = () => {
        const R = Number(pipeDiameter) / 2;
        const Areq = Number(requiredSectionArea) * 10 ** 6;

        let isWithinLimit = false;
        let baseHeight = 0;
        let upperHeight = 2 * R;
        let currentHeight = (baseHeight + upperHeight) / 2;
        let currentArea = 0;
        let materialHeight = 0;
        let theta = 0;
        let length = 0;

        const tolerance = Areq * 0.001; // 허용오차 0.1%
        const maxIteration = 100;
        let iteration = 0;

        while (!isWithinLimit && iteration < maxIteration) {
            iteration++;

            if (currentHeight < R) {
                [currentArea, materialHeight, theta, length] = calculateLower(
                    pipeDiameter,
                    surchargeAngle,
                    currentHeight,
                );
            } else {
                [currentArea, materialHeight, theta, length] = calculateUpper(
                    pipeDiameter,
                    surchargeAngle,
                    currentHeight,
                );
            }

            if (Math.abs(currentArea - Areq) < tolerance || iteration === maxIteration) {
                setMaterialHeight(materialHeight);
                setLevelHeight(currentHeight);
                setTheta(Math.ceil(((theta * 180) / Math.PI) * 10) / 10);
                setLength(Math.ceil(length * 10) / 10);
                const _maxArea = Math.PI * R ** 2;
                const _fillingRatio = (currentArea / _maxArea) * 100;
                const _maxLumpSize = (1.08 - _fillingRatio / 100) * (2 * R);
                setMaxArea(Math.ceil((_maxArea / 1000000) * 100000) / 100000);
                setFillingRatio(Math.ceil(_fillingRatio * 10) / 10);
                setMaxLumpSize(Math.ceil(_maxLumpSize * 10) / 10);
                isWithinLimit = true;

                setIsBelow(currentHeight > Number(pipeDiameter) / 2 ? false : true);
                // console.log('iteration : ', iteration);
            } else if (currentArea > Areq) {
                // 크면 currentHeight값을 upperHeight에 넣는다.
                upperHeight = currentHeight;
                currentHeight = (baseHeight + upperHeight) / 2;
            } else {
                // 작으면 currentHeight값을 baseHeight에 넣는다.
                baseHeight = currentHeight;
                currentHeight = (baseHeight + upperHeight) / 2;
            }
        }
    };

    return (
        <Modal
            title="Section Area"
            visible={isOpenModal}
            confirmText="Confirm"
            cancelText="Cancel"
            onCancel={onCancel}
            onConfirm={onConfirmMainModal}
        >
            <div style={{ display: 'flex', gap: '5rem', justifyContent: 'center' }}>
                <div
                    style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', width: '50%', minWidth: '320px' }}
                >
                    <StyledInput
                        label={
                            <ModalLabel label="Required Section Area" onClick={() => setIsOpenAreaCalcModal(true)} />
                        }
                        unit="mm"
                        value={requiredSectionArea}
                        onChange={(e) => setRequiredSectionArea(e.target.value)}
                        disabled
                    />
                    {isOpenAreaCalcModal && (
                        <Modal
                            visible={isOpenAreaCalcModal}
                            title="Calculate Required Section Area"
                            confirmText="적용"
                            cancelText="취소"
                            onConfirm={onConfirmSubModal}
                            onCancel={() => setIsOpenAreaCalcModal(false)}
                        >
                            <div>
                                <StyledInput
                                    label="Capacity"
                                    unit="tph"
                                    value={capacity}
                                    onChange={(e) => setCapacity(e.target.value)}
                                    disabled={input?.capacity ? true : false}
                                />
                                <StyledInput
                                    label="Belt Speed"
                                    unit="m/s"
                                    value={beltSpeed}
                                    onChange={(e) => setBeltSpeed(e.target.value)}
                                    disabled={input?.beltSpeed ? true : false}
                                />
                                <StyledInput
                                    label="Bulk Density"
                                    unit="kg/m3"
                                    value={bulkDensity}
                                    onChange={(e) => setBulkDensity(e.target.value)}
                                    disabled={input?.specificGravity ? true : false}
                                />
                                <StyledOutput
                                    label="Required SectionArea"
                                    unit="m2"
                                    value={requiredSectionArea}
                                    disabled
                                />
                            </div>
                        </Modal>
                    )}
                    <StyledInput
                        label={<ModalLabel label="Pipe Diameter" onClick={() => setIsOpenPipeDiaSelectModal(true)} />}
                        unit="mm"
                        value={pipeDiameter}
                        onChange={(e) => setPipeDiameter(e.target.value)}
                    />
                    {isOpenPipeDiaSelectModal && (
                        <SelectPipeDia
                            setPipeDiameter={setPipeDiameter}
                            setBeltWidth={setBeltWidth}
                            setIsOpenModal={setIsOpenPipeDiaSelectModal}
                            requiredSectionArea={requiredSectionArea}
                        />
                    )}
                    <StyledOutput label="Max. Sectional Area" unit="m2" value={toFixedSafe(maxArea, 5)} />
                    <StyledInput
                        label={
                            <AlertLabel
                                label="Surcharge Angle"
                                message={
                                    isEN ? "While the angle of repose represents the maximum slope naturally formed when bulk material is freely piled, the surcharge angle refers to the maximum inclination at which material remains stable on a conveyor belt without spilling. In other words, the angle of repose is determined by the inherent physical properties of the material, whereas the surcharge angle varies depending on the conveying environment and equipment conditions. Typically, the surcharge angle is smaller than the angle of repose." :
                                    isJP ? "安息角がバルク材が自由に積み上げられたときに自然に形成される最大傾斜角であるのに対し、サーチャージ角はコンベヤーベルト上で材料がこぼれず安定して積載される最大傾斜角を指す。つまり、安息角は材料の物理的特性によって決まるのに対し、サーチャージ角は搬送環境や設備条件によって変わり、通常、安息角より小さい。" :
                                    "휴식각이 벌크 물질이 자유롭게 쌓일 때 형성되는 최대 기울기라면, 서차지 각은 컨베이어 벨트 위에서 물질이 흘러내리지 않고 안정적으로 적재될 수 있는 최대 기울기를 의미한다. 즉, 휴식각은 물질 자체의 물리적 특성에 의해 결정되지만, 서차지 각은 운반 환경과 설비 조건에 따라 달라질 수 있으며, 보통 휴식각보다 작다."
                                }
                            />

                        }
                        unit="deg"
                        value={surchargeAngle}
                        max={90}
                        onChange={(e) => setSurchargeAngle(e.target.value)}
                    />
                    <ButtonContainer>
                        <Button
                            onClick={handleClick}
                            disabled={!isValidate}
                            variant={!isValidate ? 'Check Input!' : 'Calculate'}
                        >
                            {!isValidate ? 'Check Input!' : 'Calculate'}
                        </Button>
                    </ButtonContainer>
                    {/* 계산 결과 섹션 */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                        <StyledOutput label="Angle, 𝜃" unit="deg" value={toFixedSafe(theta, 1)} />
                        <StyledOutput label="Length, c" unit="mm" value={toFixedSafe(length, 1)} />
                        <StyledOutput label="Material Height, h'" unit="mm" value={toFixedSafe(levelHeight, 1)} />
                        <StyledOutput label="Material Height, h" unit="mm" value={toFixedSafe(materialHeight, 1)} />
                        <StyledOutput label="Max. Lump Size" unit="mm" value={toFixedSafe(maxLumpSize, 1)} />
                        <StyledOutput label="Filling Ratio" unit="%" value={toFixedSafe(fillingRatio, 1)} />
                    </div>
                </div>
                {/* 이미지 섹션 */}
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '50%',
                        minWidth: '320px',
                    }}
                >
                    {isBelow ? (
                        <img style={{ width: '100%', maxWidth: '300px' }} src={belowHalf} alt="section below 50%" />
                    ) : (
                        <img style={{ width: '100%', maxWidth: '300px' }} src={upperHalf} alt="section above 50%" />
                    )}
                </div>
            </div>
        </Modal>
    );
};

export default CalcPipeSectionArea;

// const Overlay = styled.div`
//     position: fixed;
//     inset: 0;
//     background-color: rgba(31, 41, 55, 0.5);
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     z-index: 50;
// `;

// const ModalContainer = styled.div`
//     width: 480px;
//     background-color: white;
//     border-radius: 8px;
//     box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
//     padding: 32px;
//     position: relative;
// `;

// const ContentWrapper = styled.div`
//     margin-top: 64px;
// `;

// const InputGroup = styled.div`
//     display: flex;
//     flex-direction: column;
//     gap: 12px;
// `;

// const OutputWrapper = styled.div`
//     margin-top: 24px;
// `;

const ButtonContainer = styled.div`
    // width: 100%;
    // background-color: red;
    margin-top: 1rem;
    margin-bottom: 1rem;
    // display: flex;
    // justify-content: flex-end;
    // gap: 8px;
`;

const Button = styled.button`
    width: 100%;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.2s;

    ${({ variant }) =>
        variant === 'Check Input!'
            ? `background-color: #d1d5db; color: #374151;`
            : `background-color: ${variant === 'Calculate' ? '#3b82f6' : '#d1d5db'};
         color: ${variant === 'Calculate' ? 'white' : '#374151'};
         cursor: ${variant === 'Calculate' ? 'pointer' : 'not-allowed'};
         &:hover { background-color: ${variant === 'Calculate' ? '#2563eb' : '#d1d5db'}; }`}
`;

function calculateLower(pipeDiameter, surchargeAngle, levelHeight) {
    const D = Number(pipeDiameter);
    const R = D / 2;
    const 𝛼 = (Number(surchargeAngle) * Math.PI) / 180; // 라디안 변환
    const h = Number(levelHeight);

    const 𝜃 = 2 * Math.acos((R - h) / R);
    const c = R * Math.sin(𝜃 / 2);
    const A2p = (1 / 2) * 𝜃 * R ** 2;
    const A2t = R ** 2 * Math.sin(𝜃 / 2) * Math.cos(𝜃 / 2);

    const A2 = A2p - A2t;

    const R0 = c / Math.sin(𝛼);
    const A1p = 𝛼 * R0 ** 2;
    const A1t = c ** 2 / Math.tan(𝛼);
    const A1 = A1p - A1t;

    const hp = R0 * (1 - Math.cos(𝛼));

    // Calculated Area
    const calculatedArea = Math.ceil(A1 + A2);

    // Total Material Height
    const materialHeight = Math.ceil((h + hp) * 10) / 10;

    // Filling Ratio
    // const fillingRatio = Math.ceil((calculatedArea / Math.PI) * R ** 2 * 10) / 10;

    return [calculatedArea, materialHeight, 𝜃, c];
}

function calculateUpper(pipeDiameter, surchargeAngle, levelHeight) {
    const D = Number(pipeDiameter);
    const R = D / 2;
    const 𝛼 = (Number(surchargeAngle) * Math.PI) / 180; // 라디안 변환
    const h = Number(levelHeight);

    const 𝜃 = 2 * Math.acos((h - R) / R);
    const c = R * Math.sin(𝜃 / 2);
    const A2p = (1 / 2) * 𝜃 * R ** 2 - R ** 2 * Math.sin(𝜃 / 2) * Math.cos(𝜃 / 2);
    const A2 = Math.PI * R ** 2 - A2p;

    const R0 = c / Math.sin(𝛼);
    const A1p = 𝛼 * R0 ** 2;
    const A1t = c ** 2 / Math.tan(𝛼);
    const A1 = A1p - A1t;

    const hp = R0 * (1 - Math.cos(𝛼));

    // Calculated Area
    const calculatedArea = Math.ceil(A1 + A2);

    // Total Material Height
    const materialHeight = Math.ceil((h + hp) * 10) / 10;

    // Filling Ratio
    // const fillingRatio = Math.ceil((calculatedArea / Math.PI) * R ** 2 * 10) / 10;

    return [calculatedArea, materialHeight, 𝜃, c];
}
